<template>
<!-- eslint-disable max-len -->
<list-page
  name="Playthrough"
  use="_id"
  :display="display"
  page-prefix="/blade/playthroughs"
  :fetch="getGroups"
  :remove="deleteGroup"
  :sort-options="sortOptions"
  :sort-functions="sortFunctions"
  :default-sort="defaultSort"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  data() {
    return {
      sortOptions: [
        'Last Signed In',
        'Status',
        'Player Count',
      ],
      sortFunctions: [
        this.lastSignedInSort,
        this.statusSort,
        this.playerCountSort,
      ],
      defaultSort: 0,
    };
  },
  methods: {
    ...mapActions([
      'getGroups',
      'deleteGroup',
    ]),
    display({ name: groupName, title, demo, status, players }) {
      return `${groupName || title} (${status}) ${demo ? 'ACTIVE' : ''} ${players.length} ${players.length === 1 ? 'player' : 'players'}`;
    },
    lastSignedInSort(a, b) {
      if (a.lastSignedIn == null && b.lastSignedIn == null) return 0;
      if (a.lastSignedIn == null) return 1;
      if (b.lastSignedIn == null) return -1;
      return (a.lastSignedIn > b.lastSignedIn) ? -1 : ((a.lastSignedIn < b.lastSignedIn) ? 1 : 0);
    },
    statusSort(a, b) {
      return ((a.status < b.status)
        ? -1
        : ((a.status > b.status) ? 1 : 0));
    },
    playerCountSort(a, b) {
      return ((a.players.length < b.players.length)
        ? -1
        : ((a.players.length > b.players.length) ? 1 : 0));
    },
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/GroupsList.vue